export default {
  namespaced: true,
  charts_embedder: {
    loading: "Loading...",
    select_to_begin: "Select a dataset and view to begin.",
    copy: "Copy",
    apply: "Apply",
    settings: "Settings",
    dataset: "Dataset",
    view: "View",
    language: "Language",
    time_range: "Time Range",
    custom_date: "Custom date range",
    from: "From",
    to: "To",
    select_date: "Select date...",
    advanced_filters: "Advanced Filters",
    live: "Live",
  },
};
